import axios from "axios";

const BASE_API_URL = import.meta.env.VITE_BASE_API_URL;

/**
 * A request to the Trackbook API (`<VITE_BASE_API_URL>/<endpoint>`), signed in with the session cookie.
 * Every request names the app (`agent`) and the language of the messages it returns (`lng`).
 */
export const postToApi = async <Response = unknown>(
  endpoint: string,
  lng: string,
  data: object = {}
) => {
  const response = await axios.post<Response>(
    `${BASE_API_URL}/${endpoint}`,
    { ...data, agent: "Trackbook", lng },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
};
